<div class="desktop container">
  <img [src]="brand.logoHome" alt="Logo" />
  <div class="info">
    <app-titulo>Ticket de Agendamento</app-titulo>
    <p>O seu ticket foi gerado com sucesso! faça o download abaixo.</p>
    <app-botao (click)="exportarTicket()" text="Baixar ticket" />
  </div>
</div>

<app-loader *ngIf="isLoading" />
